import * as angular from 'angular';

export class AccountService {
    static readonly $inject = ['$http'];

    constructor(private readonly http: angular.IHttpService) {}

    async getUserMetadata<T>(): Promise<angular.IHttpResponse<T>> {
        const result = await this.http.get<T>('/Account/GetUserMetaData');
        if (result.status !== 200) {
            return null;
        }
        return result;
    }

    async setUserMetadata<T>(metadata: T): Promise<void> {
        this.http.post('/Account/UpdateUserMetaData', metadata);
    }
}
